<div class="container">
  <h3 class="page-title">Pacientes</h3>
  <input
    type="text"
    autofocus
    class="form-control"
    style="margin-bottom: 15px;"
    #searchBox
    id="searchBox"
    [ngModel]="term"
    placeholder="Digite o nome do paciente para pesquisar"
    (keyup)="search(searchBox.value)" />
  <mc-patient-list [patients]="patients"></mc-patient-list>
  <blockquote class="blockquote text-center mt-5" *ngIf="patients?.length == 0">
    <p>Nenhum paciente foi encontrado, gostaria de
      <span class="h4"><strong><em>
            <a class="btn btn-outline-primary btn-lg ml-1" routerLink="novo">criar um novo?</a>
      </em></strong></span>
    </p>
  </blockquote>
</div>
